export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Reload = 'reload',
}
